import getBellsRequest from "./requests/get-bells-request";
import getBalanceRequest from "./requests/get-balance-request";
import getTariffRequest from "./requests/get-tariff-request";

const dataServiceRepository = {
    getBells: getBellsRequest,
    getBalance: getBalanceRequest,
    getTariff: getTariffRequest,
};

export default dataServiceRepository;
